"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _awsAmplify = require("aws-amplify");

/*
 * Jira Ticket:
 * Created Date: Thu, 9th Jan 2020, 12:08:16 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */
var logout = function logout() {
  return _awsAmplify.Auth.signOut({
    global: true
  }).then(function () {
    localStorage.removeItem('permissions');
  });
};

var _default = logout;
exports.default = _default;